import { features, ToggleFeature } from 'features/ToggleFeature'
import React from 'react'

const AccessibilityStatus = () => {
  return <ToggleFeature feature={features.AccessibilityStatus} />
}

export default AccessibilityStatus



// WEBPACK FOOTER //
// ./src/features/Accessibility/AccessibilityStatus.js